import { ApiClient } from '@/utils/apiClient';
import { createVueAppContext } from '@/appContext';
const http = () => {
    const appContext = createVueAppContext();
    return ApiClient(appContext);
};
export default http();
